export class BsComponentRef {
}
//# sourceMappingURL=bs-component-ref.class.js.map